import Vue from 'vue'
import VueApollo from 'vue-apollo'
import { Message } from 'element-ui'
import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { setContext } from 'apollo-link-context'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { onError } from 'apollo-link-error'
import { from } from 'apollo-link';
import { storage, cookie } from '~/common/utils/storage';

Vue.use(VueApollo)

// graphql API 的 HTTP 连接
const httpLink = new HttpLink({
  uri: '/graphql'
})

// go-graphql API 的 HTTP 连接
const httpLinkA = new HttpLink({
  uri: '/api/erp/logistics/v3/graphql'
})

const httpLinkAuth = setContext((_, { headers }) => {
  // 获取登录token
  const token = process.client ? storage.get('session_token') || storage.get('session_token', true) : ''

  // 报头返回到上下文，以便httpLink能够读取
  return {
    headers: {
      ...headers,
      'X-Session-Token': token ? token : ''
    }
  }
})

// 响应异常处理
const errorLink = onError(({ graphQLErrors, networkError, response }) => {
  let errorMsg = ''
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
    })
  }
  if (!!networkError) {
    errorMsg = networkError.message
    // if (networkError.result !== undefined) {
    //   errorMsg = networkError.result.success === false ? networkError.result.message : networkError.result.error
    // }
  }
  if (!!response && response.errors !== undefined && response.errors.length) {
    const { data, errors } = response
    // token失效
    let flag = true
    if(data?.code === 401) {
      if(process.client) {
        flag = false
        storage.rm('session_token')
        storage.rm('session_token', true)
        cookie.rm('auth')
        let routeArr = process.env.PROJECT_NAME === 'content' ? ['/content/view/questionnaire', '/content/view/invitation'] : ['/srvContent/view']
        flag = routeArr.some(item => {
          return window.location.pathname.includes(item)
        })
        if (flag) {
          window.location.reload()
        } else {
          window.location.href= window.location.origin
        }
        setTimeout(function () {
          flag = true
        }, 3000)
        return
      }
    } else if (data?.code == 403 || data?.code == 400) {
      Message.error(data?.msg)
      return
    }
    errorMsg = !errors[0].message ? '服务器错误' : errors[0].message
  }
  if (!!errorMsg) {
    Message.error(errorMsg)
  }
})

// 缓存实现
const cache = new InMemoryCache()

// 创建graphql apollo 客户端
export const apolloClient = new ApolloClient({
  link: from([httpLinkAuth, errorLink, httpLink]),
  cache
})

// go-graphql apollo 客户端
export const apolloClientA = new ApolloClient({
  link: from([errorLink, httpLinkAuth, httpLinkA]),
  cache
})

const apolloProvider = new VueApollo({
  clients: {
    go: apolloClientA
  },
  defaultClient: apolloClient
})

export default apolloProvider
